import { Card, Spinner, Text } from "@engaging-tech/components"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import useGetSurveyResultEmail from "../../hooks/useGetSurveyResultEmail"
import { getData, getIndividualCode } from "../../store/survey.selectors"
import EmailResent from "../emailResent"
import ResendEmail from "../resendEmail"

const SendResultsViaEmailAgain = ({ emailIndividualResult = true }) => {
  const { t } = useTranslation(["organisation_survey"])
  const code = useSelector(getIndividualCode)
  const { surveyId } = useSelector(getData)

  const [emailResent, setEmailResent] = useState(false)
  const {
    data,
    getData: sendEmail,
    isLoading
  } = useGetSurveyResultEmail(surveyId, code, emailIndividualResult, false)

  if (isLoading) return <Spinner justifyContent="center" color="light.0" />

  if (emailIndividualResult && emailResent && data?.getSurveyResultEmail?.statusCode === 200)
    return <EmailResent t={t} getData={sendEmail} setEmailResent={setEmailResent} />

  return (
    <Card mt={[5, 5, 6]} mb={[6, 5]} elevation={8} p={4} bg="light.0" alignItems="center">
      <Text fontSize={[3, 4]} textAlign="center" fontWeight="500" display="block" mb={2}>
        You have already completed this survey. If you need to access your results again, you can have them
        resent to your email.
      </Text>
      <ResendEmail setEmailResent={setEmailResent} sendEmail={sendEmail} />
    </Card>
  )
}

export default SendResultsViaEmailAgain
